"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrays = void 0;
exports.Arrays = {
    replace(array, index, replacement) {
        return [
            ...array.slice(0, index),
            replacement,
            ...array.slice(index + 1, array.length),
        ];
    },
    remove(array, index) {
        return [...array.slice(0, index), ...array.slice(index + 1, array.length)];
    },
};
//# sourceMappingURL=arrays.js.map